import { Button, Header, ScrollContainer, Section, StickyFooterButtons, useLoading } from "best-common-react";

import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { createPurchaseEntry, getPurchaseOpportunity } from "../../api/RequesTixApi";
import PurchaseOpportunityCard from "../../components/purchaseOpportunity/PurchaseOpportunityCard";
import PurchaseOpportunityForm from "../../components/purchaseOpportunity/PurchaseOpportunityForm";
import RouteConstants from "../../constants/RouteConstants";
import { PurchaseOpportunityDTO, PurchaseOpportunityEntryRecordDTO } from "../../types/PurchaseOpportunity";
import { useQueryClient } from "@tanstack/react-query";
import { queries } from "../../queries";

type RouteParams = {
  id: string;
};

const PurchaseOpportunityRequest: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<RouteParams>();
  const { setLoading } = useLoading();
  const [opportunity, setOpportunity] = useState<PurchaseOpportunityDTO | undefined>();
  const [entry, setEntry] = useState<PurchaseOpportunityEntryRecordDTO>({ purchaseOpportunityGameIds: [] });
  const [canSave, setCanSave] = useState<boolean>(false);
  const queryClient = useQueryClient();

  const fetchPurchaseOpportunity = async (id: string) => {
    try {
      setLoading(true);
      const res: PurchaseOpportunityDTO = await getPurchaseOpportunity(id);
      setOpportunity(res);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const saveRequest = async () => {
    try {
      setLoading(true);
      await createPurchaseEntry(entry);
      await queryClient.invalidateQueries({
        queryKey: queries.purchaseOpportunity._def,
      });
      navigate(RouteConstants.PURCHASE_OPPORTUNITY.LIST);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const cancel = () => {
    navigate(-1);
  };

  useEffect(() => {
    setEntry({
      ...entry,
      purchaseOpportunityId: parseInt(id!),
    });
    void fetchPurchaseOpportunity(id!);
  }, [id]);

  return (
    <div>
      <Header sticky title="Purchase Opportunity for Pair of Tickets">
        <StickyFooterButtons startsOpen={true}>
          <Button variant="primary" disabled={!canSave} onClick={saveRequest}>
            Submit
          </Button>
          <Button variant="default" onClick={cancel}>
            Cancel
          </Button>
        </StickyFooterButtons>
      </Header>
      <ScrollContainer className="bcr-p-2 bcr-pb-5">
        {!!opportunity && (
          <div className="d-flex flex-column flex-md-row bcr-gap-2 align-items-start">
            <PurchaseOpportunityCard opp={opportunity} className="flex-shrink-0" />
            <div className="w-100" style={{ minWidth: 0 }}>
              <Section sectionKey="request-details" header="Request Details" showToggle={false}>
                <PurchaseOpportunityForm
                  opportunity={opportunity}
                  entry={entry}
                  setEntry={setEntry}
                  setValidForm={setCanSave}
                />
              </Section>
            </div>
          </div>
        )}
      </ScrollContainer>
    </div>
  );
};

export default PurchaseOpportunityRequest;
